import textContent from 'utils/DOM/textContent'
import toggleClass from 'utils/DOM/toggleClass'
import getApplicant from 'core/renders/planDetailsCard/getApplicant'

function renderMembersSection(hcStorage) {
  // members section
  const applicant = getApplicant(hcStorage)
  textContent('.js-members-applicant', `${applicant.gender}, ${applicant.age} years Old `)
  const additionalMembers = hcStorage.members.length - 1
  if (additionalMembers > 0) {
    textContent(
      '.js-members-additional',
      `+${additionalMembers} family member${additionalMembers > 1 ? 's' : ''} `
    )
    toggleClass('.js-members-additional', 'd-none')
  }
}
export default renderMembersSection
